<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="columns onboarding-create-site__step3">
    <div
      class="column is-5 onboarding-create-site__img onboarding-create-site__img--step3 is-hidden-mobile"
      :style="`background-image: url(${imgNoivosCorrendo})`"
    ></div>
    <div class="column has-text-centered onboarding-create-site__description">
      <div class="onboarding-create-site__description--width-80">
        <h1 class="onboarding-create-site__title has-text-weight-bold">
          Qual seu principal objetivo com o Casar.com?
        </h1>
        <AnswersSquare :options="options" :rectangle="rectangle" />
      </div>
      <buttonsNext :stepNumber="stepNumber" />
    </div>
  </div>
</template>

<script>
import verifyOnboardingCompleteMixin from '@/mixins/verifyOnboardingCompleteMixin'

import buttonsNext from '@/components/OnboardingCreationSite/ButtonsNext.vue'
import AnswersSquare from '@/components/OnboardingCreationSite/OptionsAnswersSquare.vue'
import imgNoivosCorrendo from '@/assets/img/onboarding-create-site/noivos-correndo.jpg'

export default {
  mixins: [verifyOnboardingCompleteMixin],

  components: {
    buttonsNext,
    AnswersSquare,
  },

  props: {
    stepNumber: Number,
  },

  data() {
    return {
      imgNoivosCorrendo,
      rectangle: 'onboarding-create-site__options-answers-square-rectangle',
      options: [
        {
          id: 0,
          icon: '📌',
          text: 'Compartilhar informações do casamento com meus convidados',
          value: 'compartilhar_info',
        },
        {
          id: 1,
          icon: '🎁',
          text: 'Fazer a lista de presentes do nosso casamento',
          value: 'lista_presentes',
        },
        {
          id: 2,
          icon: '✅',
          text: 'Receber confirmação de presença dos convidados ',
          value: 'rsvp',
        },
        {
          id: 3,
          icon: '🗓',
          text: 'Fazer o Save the Date e Convite',
          value: 'papelaria',
        },
      ],
    }
  },
}
</script>

<style lang="scss">
.onboarding-create-site {
  &__step3 {
    display: flex;
    min-height: fit-content;
  }

  &__img {
    &--step3 {
      background-position: center;
      margin-top: 12px;
    }
  }
}
</style>
